import { default as RadioComponent } from "./radio.js";
import RadoGroup from "./radio-group.js";
const Radio = RadioComponent;
Radio.Group = RadoGroup;
export default Radio;
